const AdminOrderCard = ({ order, onView, onUpdate }) => {
  const minQty = order.prod_min_qty || 1
  const currentQty = order.current_qty || 0
  const isReady = currentQty >= minQty
  const userCount = order.user_orders?.length || 0

  return (
    <div className="col-6 mx-auto px-4 mb-4 d-flex" style={{ height: "18rem" }}>
      <div className="row border w-100 bg-white">
        {/* IMAGE */}
        <div
          className="d-flex justify-content-center align-items-center border bg-light"
          style={{ width: "18rem" }}
        >
          <img
            src={order.product_image}
            alt="product"
            className="img-fluid"
            style={{ height: "15rem" }}
          />
        </div>

        {/* DETAILS */}
        <div className="col p-3 d-flex flex-column justify-content-between">
          <div>
            <h5 className="fw-bold mb-3">{order.product_name}</h5>

            <div className="d-flex flex-column gap-1">
              <span>
                <strong>Current Qty:</strong> {currentQty}
              </span>
              <span>
                <strong>Min Qty:</strong> {minQty}
              </span>
              <span>
                <strong>Users:</strong> {userCount}
              </span>
            </div>
          </div>

          {/* STATUS + ACTIONS */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span
              className={`badge ${
                isReady ? "bg-success" : "bg-warning text-dark"
              }`}
            >
              {isReady ? "Ready" : "Pending"}
            </span>

            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => onView(order)}
              >
                View
              </button>

              <button
                className="btn btn-primary btn-sm"
                onClick={() => onUpdate(order)}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOrderCard
